import * as React from 'react';
import './index.css';

interface IState {}

interface Props {
  title?: string; // 标题居中
  rightComponent?: any;
  hideBackBtn?: boolean;
  leftTitle?: string; // 标题居左
  onClickPop?: () => void;
  customCallBack?: () => void;
  background?: string;
  containerStyle?: Record<string, any>;
}

export default class NavigationBar extends React.Component<Props, IState> {
  pop = () => {
    // @ts-ignore
    const { customCallBack } = this.props;
    if (customCallBack) {
      customCallBack();
      return;
    }
    this.props.onClickPop?.();
    const WMRouter = Mach.requireModule('Router');
    WMRouter.navigateBack();
  };

  render() {
    const statusBarHeight = Mach.env.statusBarHeight;
    const { background = '#ffffff', containerStyle } = this.props;
    return (
      <view className="container" style={{ ...containerStyle, backgroundColor: background }}>
        {/* 一定要加这一层 */}
        <view className="container-wrapper" style={{ height: Mach.env.navigationBarHeight + statusBarHeight }}>
          <view style={{ height: statusBarHeight }} />
          <view className="title-container-inner" style={{ height: Mach.env.navigationBarHeight }}>
            {!this.props.leftTitle && !!this.props.title && (
              <view className="title-text-wrapper">
                <text className="title">{this.props.title}</text>
              </view>
            )}
            {!this.props.hideBackBtn && (
              <view
                className="back-button-container"
                style={{ height: Mach.env.navigationBarHeight }}
                onClick={() => this.pop()}
              >
                <image src="assets://order/status/page_back.png" className="back-button" autoRTL />
              </view>
            )}
            {!!this.props.leftTitle && (
              <view className="left-title-container">
                <text className="title">{this.props.leftTitle}</text>
              </view>
            )}
            {this.props.rightComponent && <view className="right-wrapper">{this.props.rightComponent}</view>}
          </view>
        </view>
      </view>
    );
  }
}
